export default function DeepCopy<T>(obj: unknown): T {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (err) {
    return {} as T;
  }
}
